

const StatusPengajuanPelaporan =  {
    DRAFT : 'Draft',
    MENUNGGU_PERSETUJUAN : 'Menunggu Persetujuan',
    DISETUJUI : 'Disetujui',
    DITOLAK : 'Ditolak',
}

export default StatusPengajuanPelaporan;